import { useEffect } from 'react';

import { useCheckoutContext, Article } from '@zooplus/checkout-state';

import GridLayoutWrapper from '@components/common/grid-layout-wrapper';
import ApiErrorMessage from '@components/common/notifications/api-error-message/api-error-message';
import PageLoader from '@components/common/page-loader';
import RecommendationsCarousel from '@components/common/recommendations-carousel';
import { PAGE_TYPE, CHECKOUT_STATE_PROJECT_ID } from '@utilities/constants';
import { isArrayNotEmpty } from '@utilities/utils';

import CartEmptySection from './cart-empty-section';

const CartEmpty = () => {
  const {
    checkoutState,
    mainTogglesMap = {},
    setPageType,
  } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);

  const articles = checkoutState?.cart?.articles;
  const isNewOverviewPage = mainTogglesMap.CHECKOUT_FRONTEND_NEW_OVERVIEW_PAGE;
  const isNewPreviewPage = mainTogglesMap.CHECKOUT_FRONTEND_NEW_PREVIEW_PAGE;

  useEffect(() => {
    setPageType?.(PAGE_TYPE.WEB_EMPTY_CART);
  }, [setPageType]);

  return (
    <main>
      <GridLayoutWrapper>
        <ApiErrorMessage />
        <CartEmptySection />
        <RecommendationsCarousel pageType={PAGE_TYPE.WEB_EMPTY_CART} />
        {(!isNewOverviewPage || !isNewPreviewPage) && isArrayNotEmpty(articles as Article[]) && (
          <PageLoader />
        )}
      </GridLayoutWrapper>
    </main>
  );
};

export default CartEmpty;
